var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowUpContained({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7738 4.22746C9.69104 2.14467 6.31416 2.14467 4.23137 4.22746C2.14857 6.31026 2.14857 9.68714 4.23137 11.7699C6.31416 13.8527 9.69104 13.8527 11.7738 11.7699C13.8566 9.68714 13.8566 6.31026 11.7738 4.22746ZM3.28856 3.28465C5.89205 0.681157 10.1132 0.681157 12.7167 3.28465C15.3201 5.88815 15.3201 10.1092 12.7167 12.7127C10.1132 15.3162 5.89205 15.3162 3.28856 12.7127C0.685064 10.1092 0.685064 5.88815 3.28856 3.28465ZM7.5758 4.83486C7.82303 4.62884 8.18215 4.62884 8.42938 4.83486L11.081 7.04459C11.3639 7.2803 11.4021 7.70067 11.1664 7.98352C10.9307 8.26638 10.5103 8.30459 10.2275 8.06888L8.66925 6.77037V10.6503C8.66925 11.0185 8.37078 11.317 8.00259 11.317C7.6344 11.317 7.33592 11.0185 7.33592 10.6503V6.77037L5.77771 8.06888C5.49485 8.30459 5.07448 8.26638 4.83877 7.98352C4.60306 7.70067 4.64128 7.2803 4.92413 7.04459L7.5758 4.83486Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpContained);
export default __webpack_public_path__ + "static/media/ic-arrow-up-contained.ac68156ea1855aace88aa7ff1a793739.svg";
export { ForwardRef as ReactComponent };